export default {
  namespaced: true,
  state: () => ({
    user: null,
    authLoaded: false
  }),
  mutations: {
    updateUser(state, user) {
      state.user = user;
    },
    setAuthLoaded(state, authLoaded) {
      state.authLoaded = authLoaded;
    }
  },
  actions: {
    updateUser({ commit }, user) {
      commit("updateUser", user);
    }
  },
  getters: {
    getUser: state => state.user,
    isLoggedIn: () => {
      const token = localStorage.getItem("token");
      return !!token;
    },
    getAuthLoaded: state => state.authLoaded
  }
};
